import { Component, effect, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TopTracks } from '@shared/components/top-tracks/top-tracks';
import { TrackData } from '@shared/interfacres/track';
import { TracksList } from '@shared/components/tracks-list/tracks-list';
import { PlaylistsStore } from '@data-access/user/stores/playlists.store';
import { saveToFs } from '@shared/helpers/files.helper';
import { LibraryStore } from '@data-access/user/stores/library.store';
import { ActivatedRoute, Router } from '@angular/router';
import { DemoUserHandler } from '@shared/services/demo-user-handler';

@Component({
  selector: 'app-playlist',
  imports: [
    TopTracks,
    TracksList,
  ],
  templateUrl: './playlist-tracks.html',
  styleUrl: './playlist-tracks.scss'
})
export class PlaylistTracks implements OnInit, OnDestroy {
  @ViewChild('tracksList') tracksListElement!: ElementRef;
  @ViewChild('cont') contElement!: ElementRef;
  readonly demoUserHandlerService = inject(DemoUserHandler);
  readonly playlistsStore = inject(PlaylistsStore);
  readonly libraryStore = inject(LibraryStore);
  readonly route = inject(ActivatedRoute);
  readonly router = inject(Router);

  playlistTracks: TrackData[] = [];
  playlistName = 'Playlist Name';


  constructor() {
    effect(() => {
      this.playlistTracks = this.playlistsStore.tracks();

      this.playlistName = this.playlistTracks[0]?.playlistName || this.playlistTracks[1]?.playlistName || ''

      // if (this.playlistTracks.length > 0) {
      //   if (this.playlistTracks.length > 0) {
          // setTimeout(() => {
          //   // window.scroll({
          //   //   top: 0,
          //   //   left: 0,
          //   //   behavior: 'smooth'
          //   // });
          //   this.contElement.nativeElement.scrollIntoView({block: 'start' });
          // }, 500)
          //
          // setTimeout(() => {
          //   window.scroll({
          //     top: 0,
          //     left: 0,
          //     // behavior: 'smooth'
          //   });
          //   window.scrollTo(-10000, 0);
          // }, 1500)
      //   }
      // }

    });
  }

  ngOnInit() {
    const playlistIdentifier = this.route.snapshot.params['id'];
    if (!playlistIdentifier) {
      this.router.navigate(['/playlists'])
    }

    const segments = playlistIdentifier.split('-');
    const playlistId = +segments[0];

    this.playlistsStore.setCurrentPlaylist(playlistId);
    this.playlistsStore.getPlaylistTracks();
    // window.scroll({
    //   top: 0,
    //   left: 0,
    //   behavior: 'smooth'
    // });
  }

  ngOnDestroy() {
    this.playlistsStore.clearPlaylistData();
  }


  changePage(page: {pageIndex: number; pageSize: number}) {
    this.playlistsStore.setPlaylistPagination(page.pageIndex + 1, page.pageSize);
    this.playlistsStore.getPlaylistTracks();
  }

  sortChange(event: {active: string; direction: string}) {
    this.playlistsStore.setPlaylistFilter(event.active, event.direction as 'asc' | 'desc');
    this.playlistsStore.getPlaylistTracks();
  }

  async download(data: {id: number; title: string}) {
    const isUserValid = await this.demoUserHandlerService.isUserValid();

    if (!isUserValid) {
      return;
    }
    this.playlistsStore.increaseTrackCounter(data.id);
    this.libraryStore.increaseTopTrackCounter(data.id);
    const directLink =  await this.libraryStore.getDownloadUrl(data.id);

    if(directLink) {
      await saveToFs(directLink, data.title);
    } else {
      this.playlistsStore.decreaseTrackCounter(data.id);
      this.libraryStore.decreaseTopTrackCounter(data.id);
    }
  }
}
